@if (
  {
    pageInfos: (pageInfos$ | async)!
  };
  as context
) {
  <div class="now-fade now-left" [ngClass]="{ show: !!selectedAngebot || angebotChanging }">
    <div
      class="now-fade-content custom-padding rounded"
      [ngClass]="{ changing: angebotChanging && prevAngebot }"
    >
      @if (selectedAngebot) {
        <div class="scrollable">
          <ng-container
            *ngTemplateOutlet="angebotTemplate; context: { angebot: selectedAngebot }"
          ></ng-container>
        </div>
      }
    </div>
    @if (!selectedAngebot) {
      <div class="w-100 custom-padding" id="kein_angebot_ausgewaehlt">
        <div class="now-decorative-card now-decorative-card-default">
          <div class="d-flex flex-row empty-state">
            <img
              ngSrc="assets/images/no_angebot.svg"
              height="191"
              width="248"
              class="no-angebot"
              alt=""
            />
            <div class="d-flex flex-column ms-3">
              <h3 class="now-heading">
                <span aria-hidden="true" class="fw-bold">{{
                  context.pageInfos.totalResults | number
                }}</span>
                <span
                  >{{
                    context.pageInfos.totalResults | i18nPlural: anzahlAngebotePlural
                  }}
                  gefunden</span
                >
              </h3>
              <p class="now-copytext">
                Wählen Sie <span class="fw-bold">links ein Angebot</span> aus, um Termine zu sehen
                und weitere Details zu erfahren.
              </p>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
